// GENERATED FILE — do not edit. Source of truth: contracts/. Regenerate: node scripts/sync-contracts.mjs

import { api } from '../apiClient';

import { z } from 'zod';
// Runtime validation: every named type above has a matching `<Name>Schema` zod export — the
// exact schema the backend validates with (story 2-92), so forms can `.parse()`/`.safeParse()`
// against it instead of hand-rolling checks. `.refine()` cross-field rules are preserved
// verbatim; the refine() error MESSAGE is not — the server owns user-facing text.

export type QuotaMetric = "reportsPerMonth" | "pdfExportsPerMonth" | "agentCallsPerMonth" | "templates" | "seats";
export const QuotaMetricSchema = z.enum(["reportsPerMonth", "pdfExportsPerMonth", "agentCallsPerMonth", "templates", "seats"] as const);

export type ExplainQuery = {
  userId?: string | undefined;
  email?: string | undefined;
  orgId: string;
  capability?: string | undefined;
  featureKey?: string | undefined;
  metric?: QuotaMetric | undefined;
};
export const ExplainQuerySchema = z.object({
  userId: z.string().min(1).max(64).optional(),
  email: z.string().min(1).max(200).optional(),
  orgId: z.string().min(1).max(64),
  capability: z.string().min(1).max(80).optional(),
  featureKey: z.string().min(1).max(80).optional(),
  metric: QuotaMetricSchema.optional(),
}).strict();

export type TraceRow = {
  layer: string;
  label: string;
  verdict: "allow" | "deny" | "not_applicable" | "info";
  rule: string;
  reason: string | null;
  reached: boolean;
  detail?: Record<string, unknown> | undefined;
};
export const TraceRowSchema = z.object({
  layer: z.string(),
  label: z.string(),
  verdict: z.enum(["allow", "deny", "not_applicable", "info"] as const),
  rule: z.string(),
  reason: z.string().nullable(),
  reached: z.boolean(),
  detail: z.record(z.unknown()).optional(),
}).strict();

export type PolicyExplainResult = {
  principal: {
  userId: string | null;
  email: string | null;
  found: boolean;
  platformRole: string | null;
  actorOrgId: string | null;
};
  target: {
  orgId: string;
  capability: string | null;
  featureKey: string | null;
  metric: string | null;
};
  trace: Array<TraceRow>;
  allow: boolean;
  reason: string;
};
export const PolicyExplainResultSchema = z.object({
  principal: z.object({
    userId: z.string().nullable(),
    email: z.string().nullable(),
    found: z.boolean(),
    platformRole: z.string().nullable(),
    actorOrgId: z.string().nullable(),
  }).strict(),
  target: z.object({
    orgId: z.string(),
    capability: z.string().nullable(),
    featureKey: z.string().nullable(),
    metric: z.string().nullable(),
  }).strict(),
  trace: z.array(TraceRowSchema),
  allow: z.boolean(),
  reason: z.string(),
}).strict();

export type ExplainPolicyResponse = {
  data: PolicyExplainResult;
};

export async function explainPolicy(query?: ExplainQuery): Promise<ExplainPolicyResponse> {
  const response = await api.get<ExplainPolicyResponse>(`/platform/policy/explain`, { params: query });
  return response.data;
}

export const policyKeys = {
  all: ["policy"] as const,
  lists: () => [...policyKeys.all, 'list'] as const,
  list: (filters?: Record<string, unknown>) =>
    [...policyKeys.lists(), ...(filters ? [filters] : [])] as const,
  details: () => [...policyKeys.all, 'detail'] as const,
  detail: (id: string) => [...policyKeys.details(), id] as const,
};
